import { render, staticRenderFns } from "./TodoList.vue?vue&type=template&id=22a3c9c9"
import script from "./TodoList.vue?vue&type=script&lang=js"
export * from "./TodoList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/componenterpserver/gitrepo/unitmodeler/jp-ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('22a3c9c9')) {
      api.createRecord('22a3c9c9', component.options)
    } else {
      api.reload('22a3c9c9', component.options)
    }
    module.hot.accept("./TodoList.vue?vue&type=template&id=22a3c9c9", function () {
      api.rerender('22a3c9c9', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/modules/flowable/task/TodoList.vue"
export default component.exports